import { Mark } from 'tiptap';
import { updateMark } from 'tiptap-commands';

export default class BackgroundColor extends Mark {
  get name() {
    return 'background_color';
  }

  get schema() {
    return {
      attrs: {
        backgroundColor: {
          default: '',
        },
      },
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: [{
        style: 'background-color',
        getAttrs: (mark) => ({ backgroundColor: mark }),
      }],
      toDOM: (mark) => ['span', { style: `background-color: ${mark.attrs.backgroundColor}` }, 0],
    };
  }

  commands({ type }) {
    return (attrs) => updateMark(type, attrs);
  }
}
